import { render, staticRenderFns } from "./CategoriseContent.vue?vue&type=template&id=0e164c92&scoped=true&"
import script from "./CategoriseContent.vue?vue&type=script&lang=js&"
export * from "./CategoriseContent.vue?vue&type=script&lang=js&"
import style0 from "./CategoriseContent.vue?vue&type=style&index=0&id=0e164c92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e164c92",
  null
  
)

export default component.exports